module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-error-92484b86eeb75aaf589e01bcc7c9277c.svg";